import { Component, EventEmitter, Inject, Input, OnChanges, Output, SimpleChanges } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import {
  DireccionModel,
  DireccionControllerService,
  AcuerdoIndirectoDTO,
} from 'api-rest';
import { AdressDialogComponent } from '../adress-dialog/adress-dialog.component';
import swal from 'sweetalert2'
import { SpinnerService } from '../../services/spinner.service';
import { EmpusaAuthenticationService } from '@empusa/empusa-core';
import { SnackbarService } from '../../services/snackbar.service';

const ESTADO_BAJA = 6;

@Component({
  selector: 'managers-agreements-detail-adress',
  templateUrl: './detail-adress.component.html',
  styleUrls: ['./detail-adress.component.scss']
})

export class DetailAdressComponent implements OnChanges {
  @Input() acuerdoIndirectoInfo!: AcuerdoIndirectoDTO;
  @Input() soloLectura = false;
  @Output() public refrescarAdheridoEvent = new EventEmitter<any>();
  direcciones: DireccionModel[] = [];

  gridArray!: DireccionModel[];
  headArray: any = [
    {
      Head: 'Requerida',
      FieldName: 'requerido',
      check: true,
      disabled: true,
      width: '1'
    },
    {
      Head: 'Tipo direccion',
      FieldName: 'tipoDireccion',
      Attribute: 'descripcion',
      width: '2'
    },
    {
      Head: 'Dirección',
      FieldName: 'fullAddress',
      Tooltip: true,
      width: '8',
      Maxtext: 50
    },
    {
      'Head': 'Acciones', 'FieldName': 'actions', 'buttons':
        [
          { 'nameButton': "view", "icon": "open_in_new", 'toolTip': 'Detalle', 'show': { 'params': 'canAccessView', 'accion': 'view' } },
          { 'nameButton': "delete", "icon": "delete", 'toolTip': 'Borrar', 'show': { 'params': 'canAccessDelete', 'accion': 'delete' } },
        ], width: '2'
    },
  ];

  constructor(
    private dialog: MatDialog,
    private direccionControllerSrv: DireccionControllerService,
    @Inject('EmpusaAuthenticationService') private authService: EmpusaAuthenticationService,
    private spinnerSrv: SpinnerService,
    private snackBarSrv: SnackbarService,) {

     }

  ngOnChanges(changes: SimpleChanges): void {
    if (this.acuerdoIndirectoInfo) {
      this.direcciones = this.acuerdoIndirectoInfo?.domicilios ?? [];
      this.gridArray = this.canAccessAll(this.direcciones);
    }
  }

  canAccessCreateDireccion(): boolean {
    return (
      !this.soloLectura &&
      this.authService.can('adheridos-direcciones', 'create') &&
      this.acuerdoIndirectoInfo?.estado?.id !== 7
    );
  }

  canAccessExportar(): boolean {
    return this.authService.can('adheridos-direcciones', 'access-b-exportar');
  }

  canAccessAll(list: any) {
    const resultListShow = true
     //this.authService.can('adheridos-direcciones', 'access');
    const resultListEdit = true
    //this.authService.can('adheridos-direcciones', 'update');
    const resultDelete = true
    //this.authService.can('adheridos-direcciones', 'delete');

    const listPermission = list.map((objeto: any) => {
      const estadoUpdatedAddress =true
       //this.acuerdoIndirectoInfo.estado && [2, 3, 4, 5, 6].includes(this.acuerdoIndirectoInfo.estado!.id as number);
      const estadoEliminar = true
      //this.acuerdoIndirectoInfo.estado && [1, 2, 3, 4, 5, 6].includes(this.acuerdoIndirectoInfo.estado!.id as number) && (!objeto.requerido || objeto.requerido === null);

      return { ...objeto, canAccessView: resultListShow, canAccessListEdit: !this.soloLectura && resultListEdit && estadoUpdatedAddress, canAccessDelete: !this.soloLectura && resultDelete && estadoEliminar };

    });

    return listPermission;
  }

  abrirModalDirecciones(element?: DireccionModel): void {
    const dialogRef = this.dialog.open(
      AdressDialogComponent,
      {
        width: '950px',
        maxWidth: '95%',
        maxHeight: '95vh',
        data: {
          direccion: element,
          acuerdoIndirectoInfo: this.acuerdoIndirectoInfo,
          soloLectura: this.soloLectura || this.acuerdoIndirectoInfo?.estado?.id === ESTADO_BAJA,
        },
        disableClose: true
      }
    );
    dialogRef.afterClosed().subscribe(
      result => {
        if (result) {
          this.refrescarAdheridoEvent.emit(true);
        }
      }
    );
  }

  confirmacionEliminar(element?: DireccionModel): void {
    swal.fire({
      text: '¿Desea eliminar la dirección?',
      icon: 'question',
      showDenyButton: true,
      showCancelButton: false,
      confirmButtonText: 'Sí',
      denyButtonText: 'No',
      allowOutsideClick: false
    }).then((result: any) => {
      if (result.isConfirmed) {
        this.eliminarDireccion(element);
      }

    });
  }
  eliminarDireccion(element?: DireccionModel) {
    if (element?.id) {
      this.spinnerSrv.loadingShow();
      this.direccionControllerSrv.borrarDireccion(element.id).subscribe({
        next: response => {
          this.spinnerSrv.loadingHide();
          this.refrescarAdheridoEvent.emit(true);
          this.snackBarSrv.showSnackBar('La dirección se ha eliminado correctamente', 'success');
        },
        error: err => {
          this.spinnerSrv.loadingHide();
          this.snackBarSrv.showSnackBar('Ha ocurrido un error al eliminar la dirección', 'error');
          console.log(err);
        }
      });
    }
  }

  action(item: any) {
    const row = item?.row ?? item?.item ?? item;
    if (item.nameButton == 'view') {
      this.abrirModalDirecciones(row);
    } else if (item.nameButton == 'edit') {
      this.abrirModalDirecciones(row);
    } else if (item.nameButton == 'delete') {
      this.confirmacionEliminar(row);
    }
  }

  canViewRol(rol: string): boolean {
    return this.authService.hasCurrentUserRole(rol);
  }
}

